import type React from "react";

import {faBrush} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";
import {useSelection} from "~/three/selection/useSelection";

import useModal from "../../../../hooks/useModal";
import GameObjectContent from "./ObjectSelectorContent";

const GameObjectModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();
  const {currentGameObjectType} = useSelection();

  const backgroundImageStyle = currentGameObjectType.current
    ? {
        backgroundImage: `linear-gradient(to bottom right, rgba(0, 0, 0, 0.9), transparent, black), url(/images/item_preview/${currentGameObjectType.current}.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  return (
    <>
      <CustomButton
        onClick={openModal}
        aria-label="Select object"
        style={backgroundImageStyle}
        className="p-2 rounded-full flex items-center justify-center"
      >
        <FontAwesomeIcon
          icon={faBrush}
          size="xl"
          className="text-white p-2 -m-2 rounded-full pl-2.5 pr-2.5"
        />
      </CustomButton>
      <Modal>
        <GameObjectContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default GameObjectModalButton;
